<template>
    <div>
      <div class="cui__utils__heading">
        <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
      </div>
      <div class="card">
        <div class="card-header card-header-flex">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5 class="mb-0"></h5>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <a class="btn btn-primary" href="javascript: void(0);"  @click="showModal('insert')">เพิ่มชุดบัญชี</a>
          </div>
        </div>
        <div class="card-body">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0"></h5>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
                class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
            </div>
          </div>
          <a-table :columns="columns" :dataSource="data" rowKey='id' :scroll="{ x: 1500 }"
          :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
            <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              class="custom-filter-dropdown"
            >
              <a-input
                v-ant-ref="c => searchInput = c"
                :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm)"
                style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                type="primary"
                @click="() => handleSearch(selectedKeys, confirm)"
                size="small"
                style="width: 90px; margin-right: 8px"
              >Search</a-button>
              <a-button
                @click="() => handleReset(clearFilters)"
                size="small"
                style="width: 90px"
              >Reset</a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <!-- <a
              slot="id"
              slot-scope="text"
              href="javascript: void(0);"
              class="btn btn-sm btn-light"
            >{{text}}</a> -->
            <template slot="name" slot-scope="text">
              <span v-if="searchText">
                <template
                  v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
                >
                  <mark
                    v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                    :key="i"
                    class="highlight"
                  >{{fragment}}</mark>
                  <template v-else>{{fragment}}</template>
                </template>
              </span>
              <template v-else>
                <a class="btn btn-sm btn-light" href="javascript: void(0);">{{text}}</a>
              </template>
            </template>
            <template slot="progress" slot-scope="bar">
              <div class="progress">
                <div
                  :class="['progress-bar', bar.color]"
                  :style="{width: bar.value + '%'}"
                  role="progressbar"
                ></div>
              </div>
            </template>
            <a slot="actionQRMinAmount" slot-scope="text, record"
            >{{setComma(record.QRMinAmount)}}</a>
            <a slot="actionQRMaxAmount" slot-scope="text, record"
            >{{setComma(record.QRMaxAmount)}}</a>
            <a slot="actionQRMaxTransection" slot-scope="text, record"
            >{{setComma(record.QRMaxTransection)}}</a>
            <a slot="actionBillMinAmount" slot-scope="text, record"
            >{{setComma(record.BillMinAmount)}}</a>
            <a slot="actionBillMaxAmount" slot-scope="text, record"
            >{{setComma(record.BillMaxAmount)}}</a>
            <a slot="actionBillMaxTransection" slot-scope="text, record"
            >{{setComma(record.BillMaxTransection)}}</a>
            <h6 slot="status" slot-scope="text, record">
            <b-badge
              pill
              :variant="getStatus('GBPrimpay', text).color"
              href="#"
              @click="useAction(record.id, text)"
              >{{ getStatus("GBPrimpay", text).name }}</b-badge
            >
          </h6>
            <span slot="action" slot-scope="text,record">
              <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item @click="showModal('update',record.id)">แก้ไขบัญชีร้านค้า </a-menu-item>
                <a-menu-item @click="closewGBPrimpay(record.id , record.status)">{{record.status !== 2 ?'เลิกใช้งาน':'เปิดใช้งาน'}} </a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px"> จัดการ <a-icon type="down" /> </a-button>
            </a-dropdown>
            </span>
          </a-table>
        </div>
      </div>
        <a-modal title="จัดการข้อมูลบัญชีร้านค้า" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk" :confirm-loading="confirmLoading"
          @cancel="handleCancel">
            <a-form-model ref="ruleForm" :model="form" :rules="rules" layout="vertical">
                <div class="row">
                    <div class="col-md-12">
                        <a-form-model-item label="ชื่อบัญชี" prop="name">
                        <a-input v-model="form.name" />
                        </a-form-model-item>
                    </div>
                    <div class="col-md-12">
                        <a-form-model-item label="คู่ค้า" prop="operatorMainId">
                        <a-select v-model="form.operatorMainId" placeholder="กรุณาเลือกข้อมูล">
                            <a-select-option v-for="(item , index) in operator" :key="index" :value="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                        </a-form-model-item>
                    </div>
                    <div class="col-md-12">
                        <a-form-model-item label="domainGB" prop="domainGB">
                        <a-input v-model="form.domainGB" />
                        </a-form-model-item>
                    </div>
                    <div class="col-md-12">
                        <a-form-model-item label="ipGB" prop="ipGB">
                        <a-input v-model="form.ipGB" />
                        </a-form-model-item>
                    </div>
                    <div class="col-md-6">
                        <a-form-model-item label="เติมเงิน Qr ขั้นต่ำ" prop="QRMinAmount">
                        <a-input v-model="form.QRMinAmount" />
                        </a-form-model-item>
                    </div>
                    <div class="col-md-6">
                        <a-form-model-item label="เติมเงิน Qr สูงสุด" prop="QRMaxAmount">
                        <a-input v-model="form.QRMaxAmount" />
                        </a-form-model-item>
                    </div>
                    <div class="col-md-6">
                        <a-form-model-item label="เติมเงิน Qr รับสูงสุดต่อวัน" prop="QRMaxTransection">
                        <a-input v-model="form.QRMaxTransection" />
                        </a-form-model-item>
                    </div>
                    <div class="col-md-6">
                        <a-form-model-item label="เติมเงิน Bill ขั้นต่ำ" prop="BillMinAmount">
                        <a-input v-model="form.BillMinAmount" />
                        </a-form-model-item>
                    </div>
                    <div class="col-md-6">
                        <a-form-model-item label="เติมเงิน Bill สูงสุด" prop="BillMaxAmount">
                        <a-input v-model="form.BillMaxAmount" />
                        </a-form-model-item>
                    </div>
                    <div class="col-md-6">
                        <a-form-model-item label="เติมเงิน Bill รับสูงสุดต่อวัน" prop="BillMaxTransection">
                        <a-input v-model="form.BillMaxTransection" />
                        </a-form-model-item>
                    </div>
                </div>
            </a-form-model>
        </a-modal>
    </div>
  </template>
<script>
import { Modal, notification } from 'ant-design-vue'
// import data from './data.json'
//   import moment from 'moment'
import apiClient from '@/services/api'
import { getName } from '@/utils/status'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
const columns = [
  {
    title: 'ไอดี',
    dataIndex: 'id',
    width: 100,
    sorter: (a, b) => a.id - b.id,
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
      customRender: 'id',
    },
    onFilter: (value, record) => record.id.toString().includes(value.toString()),
  },
  {
    title: 'คู่ค้า',
    dataIndex: 'operatorMainName',
    filters: [],
    // sorter: (a, b) => a.operatorMainName.length - b.operatorMainName.length,
    // scopedSlots: {
    //   filterDropdown: 'filterDropdown',
    //   filterIcon: 'filterIcon',
    //   customRender: 'operatorMainName',
    // },
    onFilter: (value, record) => record.operatorMainName.toLowerCase().includes(value.toLowerCase()),
  },
  {
    title: 'ชื่อ',
    dataIndex: 'name',
    sorter: (a, b) => a.name.length - b.name.length,
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
      customRender: 'name',
    },
    onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
  },
  {
    title: 'เติมเงิน Qr ขั้นต่ำ',
    dataIndex: 'QRMinAmount',
    scopedSlots: { customRender: 'actionQRMinAmount' },
  },
  {
    title: 'เติมเงิน Qr สูงสุด',
    dataIndex: 'QRMaxAmount',
    scopedSlots: { customRender: 'actionQRMaxAmount' },
  },
  {
    title: 'เติมเงิน Qr รับสูงสุดต่อวัน',
    dataIndex: 'QRMaxTransection',
    scopedSlots: { customRender: 'actionQRMaxTransection' },
  },
  {
    title: 'เติมเงิน Bill ขั้นต่ำ',
    dataIndex: 'BillMinAmount',
    scopedSlots: { customRender: 'actionBillMinAmount' },
  },
  {
    title: 'เติมเงิน Bill สูงสุด',
    dataIndex: 'BillMaxAmount',
    scopedSlots: { customRender: 'actionBillMaxAmount' },
  },
  {
    title: 'เติมเงิน Bill รับสูงสุดต่อวัน',
    dataIndex: 'BillMaxTransection',
    scopedSlots: { customRender: 'actionBillMaxTransection' },
  },
  {
    title: 'สถานะ',
    dataIndex: 'status',
    filters: [
      { text: 'ปิดใช้งาน', value: 0 },
      { text: 'เปิดใช้งาน', value: 1 },
      { text: 'เลิกใช้งาน', value: 2 },
    ],
    scopedSlots: { customRender: 'status' },
    onFilter: (value, record) => record.status.toString().includes(value.toString()),
  },
  {
    title: 'จัดการ',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  data: function () {
    return {
      visible: false,
      searchText: '',
      searchInput: null,
      confirmLoading: false,
      data: [],
      operator: [],
      columns,
      formLayout: 'horizontal',
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      form: {
        id: '',
        name: '',
        domainGB: '',
        ipGB: '',
        operatorMainId: '',
        status: 1,
        QRMinAmount: '',
        QRMaxAmount: '',
        QRMaxTransection: '',
        BillMinAmount: '',
        BillMaxAmount: '',
        BillMaxTransection: '',
      },
      rules: {
        name: [
          { required: true, message: 'กรุณากรอกชื่อ', trigger: 'blur' },
        ],
        domainGB: [
          { required: true, message: 'กรุณากรอก domainGB', trigger: 'blur' },
        ],
        ipGB: [
          { required: true, message: 'กรุณากรอก ipGB', trigger: 'blur' },
        ],
        operatorMainId: [
          { required: true, message: 'กรุณาเลือก operatorMain', trigger: 'change' },
        ],
        QRMinAmount: [
          { required: true, message: 'กรุณากรอกเติมเงิน Qr ขั้นต่ำ', trigger: 'blur' },
        ],
        QRMaxAmount: [
          { required: true, message: 'กรุณากรอกเติมเงิน Qr สูงสุด', trigger: 'blur' },
        ],
        QRMaxTransection: [
          { required: true, message: 'กรุณากรอกเติมเงิน Qr รับสูงสุดต่อวัน', trigger: 'blur' },
        ],
        BillMinAmount: [
          { required: true, message: 'กรุณากรอกเติมเงิน Bill ขั้นต่ำ', trigger: 'blur' },
        ],
        BillMaxAmount: [
          { required: true, message: 'กรุณากรอกเติมเงิน Bill สูงสุด', trigger: 'blur' },
        ],
        BillMaxTransection: [
          { required: true, message: 'กรุณากรอกเติมเงิน Bill รับสูงสุดต่อวัน', trigger: 'blur' },
        ],
      },
    }
  },
  // mounted() {
  //   this.loaddata()
  // },
  methods: {
    showModal(type, id = null) {
      // get OpertorCode
      this.clearForm()
      apiClient.get('/system/getOperator').then(res => {
        if (res.data.code === '000') {
          this.operator = []
          this.operator = res.data.responseData.data
          if (type === 'update') {
            this.getDataGBPrimpay(id)
          } else {
            this.visible = !this.visible
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    getDataGBPrimpay(GBPrimpayId) {
      apiClient.get(`/GBPrimpay/${GBPrimpayId}`).then(res => {
        if (res.data.code === '000') {
          const dataGBPrimpay = res.data.responseData.data[0]
          this.form = {
            id: dataGBPrimpay.id,
            name: dataGBPrimpay.name,
            domainGB: dataGBPrimpay.domainGB,
            ipGB: dataGBPrimpay.ipGB,
            operatorMainId: dataGBPrimpay.operatorMainId,
            status: dataGBPrimpay.status,
            QRMinAmount: dataGBPrimpay.QRMinAmount,
            QRMaxAmount: dataGBPrimpay.QRMaxAmount,
            QRMaxTransection: dataGBPrimpay.QRMaxTransection,
            BillMinAmount: dataGBPrimpay.BillMinAmount,
            BillMaxAmount: dataGBPrimpay.BillMaxAmount,
            BillMaxTransection: dataGBPrimpay.BillMaxTransection,
          }

          this.visible = !this.visible
        }
      }).catch(error => {
        Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    clearForm() {
      this.form = {
        id: '',
        name: '',
        domainGB: '',
        ipGB: '',
        operatorMainId: '',
        status: 1,
        QRMinAmount: '',
        QRMaxAmount: '',
        QRMaxTransection: '',
        BillMinAmount: '',
        BillMaxAmount: '',
        BillMaxTransection: '',
      }
    },
    useAction(GBPrimpayId, status) {
      if (status === 1) this.updatebankGBPrimpay(GBPrimpayId, 'openStatus')
      if (status === 0) this.updatebankGBPrimpay(GBPrimpayId, 'blockStatus')
    },
    async updatebankGBPrimpay(GBPrimpayId, type) {
      const status = (type === 'openStatus') ? 0 : (type === 'blockStatus') ? 1 : null
      const title = (type === 'openStatus') ? 'คุณแน่ใจหรือไม่ที่ต้องการปิดใช้งาน' : (type === 'blockStatus') ? 'คุณแน่ใจหรือไม่ที่ต้องการเปิดการใช้งาน' : null

      if (status !== '') {
        await Swal.fire({
          title: title,
          icon: 'question',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          showCancelButton: true,
          showCloseButton: true,
          showLoaderOnConfirm: true,
          preConfirm: (value) => {
            if (value) {
              const data = { status }
              return apiClient.put(`/GBPrimpay/updateStatus/${GBPrimpayId}`, data).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                    `Request failed: ${error.message}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message })
            this.loaddata()
          }
        })
      }
    },
    getDataEdit() {

    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    loaddata() {
      apiClient.get('GBPrimpay/getData').then(res => {
        if (res.data.code === '000') {
          this.data = res.data.responseData
          // if (this.data.length > 0) {
          //   const listOperater = this.data.map(function(item, pos) {
          //     return { text: item.operatorMainName, value: item.operatorMainName }
          //   })
          //   this.columns[1].filters = [
          //     ...new Map(listOperater.map((item) => [item.text, item])).values(),
          //   ]
          // }
        }
      })
    },
    showView(viewid = null) {
      // console.log(viewid)
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const title = (this.form.id !== '') ? 'แน่ใจหรือไม่ที่ต้องการแก้ไข' : 'แน่ใจหรือไม่ที่ต้องการเพิ่มข้อมูล'
          Swal.fire({
            icon: 'info',
            title: title,
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              if (value) {
                if (this.form.id !== '') {
                  return apiClient.put(`GBPrimpay/update/${this.form.id}`, this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                        `เกิดข้อผิดพลาด: ${error}`,
                    )
                  })
                } else {
                  return apiClient.post('GBPrimpay/create', this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                        `เกิดข้อผิดพลาด: ${error}`,
                    )
                  })
                }
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const iconError = (result.value.code === '000') ? 'success' : 'error'
              Toast.fire({
                icon: iconError,
                title: result.value.message,
              })
              this.visible = false
              this.confirmLoading = false
              this.loaddata()
            }
          })
        }
      })
    },
    handleOk(e) {
      this.confirmLoading = true
      this.onSubmit()
    },
    handleCancel(e) {
      this.visible = false
    },
    setComma(value) {
      if (value > 0 && value !== null) {
        return value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    },
    showDeleteConfirm(delid = null) {
      Modal.confirm({
        title: 'ยืนยันการลบข้อมูล ?',
        content: 'ยืนยันการลบข้อมูล',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          apiClient.delete(`bankSet/delete/${delid}`).then(res => {
            if (res.data.code === '000') {
              notification.success({
                message: res.data.message,
              })
            } else {
              notification.warning({
                message: res.data.message,
              })
            }
            this.loaddata()
          })
        },
        onCancel() {
          // console.log('Cancel')
        },
      })
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    closewGBPrimpay(GBPrimpayId, Status) {
      const title = Status !== 2 ? 'ยืนยันการเลิกใช้งาน ?' : 'ยืนยันการเปิดใช้งาน ?'
      const content = Status !== 2 ? 'ยืนยันการเลิกใช้งาน' : 'ยืนยันการเปิดใช้งาน'
      Modal.confirm({
        title: title,
        content: content,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          const status = Status !== 2 ? 2 : 1
          const data = { status }
          apiClient.put(`GBPrimpay/close/${GBPrimpayId}`, data).then(res => {
            if (res.data.code === '000') {
              notification.success({
                message: res.data.message,
              })
            } else {
              notification.warning({
                message: res.data.message,
              })
            }
            this.loaddata()
          })
        },
        onCancel() {
        },
      })
    },
    refreshData() {
      this.loading(true)
      this.loaddata()
      this.loading(false)
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
  },
  created() {
    this.loaddata()
  },
}
</script>
  <style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }

  .badge.badge-black.badge-pill {
      font-weight: normal;
      background: #000;
      color: #ebebef;
      letter-spacing: 1px;
      text-transform: uppercase;
  }
  </style>
